export enum AppBrandingSources {
  VODAFONE = 'vodafone',
  HARVEY_NORMAN = 'harvey_norman_techteam_plus',
  DIRECTV = 'directv',
  TECH_EXPERT = 'tech_expert',
  ASSURANT_TECH_PRO = 'assurant_tech_pro',
  TMO_PGH = 'protection_360_home_tech',
  XTDP = 'xfinity_total_device_protection',
  OTHER = 'others',
  VODAFONE_PORTUGAL = 'vodafone_portugal',
}
